"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeSettingsComponent = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var input_select_1 = require("../../components/input/input.select");
var input_state_group_1 = require("../../components/input/input.state.group");
var mithril_component_1 = require("../../components/mithril.component");
var modal_service_1 = require("../../components/modal/modal.service");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var user_settings_service_1 = require("../../services/user.settings.service");
var CSS = {
    error: 'c-Settings__error',
    saved: 'c-Settings__saved'
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.saved] = {
        color: '',
        'padding-left': theme_1.DefaultTheme.space(2),
        height: theme_1.DefaultTheme.space(6)
    },
    _a));
var ChangeSettingsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ChangeSettingsComponent, _super);
    function ChangeSettingsComponent() {
        var _this = _super.call(this) || this;
        _this.changingSettings = false;
        _this.dateFormat = new input_select_1.SelectInputState(i18n_1.T.SETTINGS_DATE_FORMAT);
        _this.units = new input_select_1.SelectInputState(i18n_1.T.SETTINGS_UNITS);
        _this.form = new input_state_group_1.IkeInputStateGroup();
        _this.form.add(_this.units);
        _this.form.add(_this.dateFormat);
        user_settings_service_1.UNIT_OPTIONS.forEach(function (unit) { return _this.units.addOption({ key: (0, i18n_1.Translate)(unit.label), value: unit.unit }); });
        user_settings_service_1.DATE_OPTIONS.forEach(function (dateFormat) { return _this.dateFormat.addOption({ key: dateFormat, value: dateFormat }); });
        return _this;
    }
    Object.defineProperty(ChangeSettingsComponent.prototype, "nodes", {
        get: function () {
            return [
                input_select_1.SelectInputComponent.view(this.dateFormat),
                input_select_1.SelectInputComponent.view(this.units)
            ];
        },
        enumerable: false,
        configurable: true
    });
    ChangeSettingsComponent.prototype.viewActions = function () {
        var submitChildren = this.changingSettings ? spinner_1.Spinner.view() : (0, i18n_1.Translate)(i18n_1.T.SETTINGS_DONE);
        return (0, mithril_1.m)('button', { className: 'mdl-button', disabled: this.changingSettings, type: 'submit' }, submitChildren);
    };
    ChangeSettingsComponent.prototype.reset = function () {
        this.changingSettings = false;
        this.form.reset();
        this.units.setValue(services_1.Services.UserSettings.units);
        this.dateFormat.setValue(services_1.Services.UserSettings.dateFormat);
    };
    ChangeSettingsComponent.prototype.open = function () {
        var _this = this;
        this.reset();
        this.autorun(function (_) { return _this.updateSettings(); });
        modal_service_1.ModalService.open({
            title: i18n_1.T.SETTINGS_TITLE,
            content: function (_) { return _this.view(); },
            actions: function (_) { return _this.viewActions(); },
            onSubmit: function (_) { return _this.close(); }
        });
    };
    ChangeSettingsComponent.prototype.setDone = function (e) {
        this.changingSettings = false;
        this.reset();
        if (e) {
            notification_service_1.NotificationService.error({ key: i18n_1.T.SETTINGS_ERROR_SAVING });
        }
        else {
            notification_service_1.NotificationService.success({ key: i18n_1.T.SETTINGS_SAVED });
        }
    };
    ChangeSettingsComponent.prototype.watchProgress = function (promise) {
        var _this = this;
        this.form.setDisabled(true);
        this.changingSettings = true;
        promise
            .then(function (_) { return _this.setDone(); })
            .catch(function (e) { return _this.setDone(e); });
    };
    ChangeSettingsComponent.prototype.updateSettings = function () {
        var currentUnits = this.units.value;
        var currentDateFormat = this.dateFormat.value;
        if (currentUnits !== services_1.Services.UserSettings.units) {
            this.watchProgress(services_1.Services.UserSettings.setUnits(currentUnits));
            return true;
        }
        if (currentDateFormat !== services_1.Services.UserSettings.dateFormat) {
            this.watchProgress(services_1.Services.UserSettings.setDateFormat(currentDateFormat));
            return true;
        }
        return false;
    };
    ChangeSettingsComponent.prototype.close = function () {
        if (modal_service_1.ModalService.isOpen) {
            modal_service_1.ModalService.close(false);
        }
        this.reset();
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], ChangeSettingsComponent.prototype, "changingSettings", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ChangeSettingsComponent.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ChangeSettingsComponent.prototype, "open", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ChangeSettingsComponent.prototype, "setDone", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ChangeSettingsComponent.prototype, "watchProgress", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ChangeSettingsComponent.prototype, "close", null);
    return ChangeSettingsComponent;
}(mithril_component_1.IMithrilStateComponent));
exports.ChangeSettingsComponent = ChangeSettingsComponent;
//# sourceMappingURL=change.settings.js.map